module.exports = __webpack_public_path__ + "img/004.2a09f359.jpg";